import gsap from 'gsap';

import {
  ScrollTrigger
} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/* Navigation - Pin */
ScrollTrigger.create({
  trigger: ".navbar.bg-white",
  start: "top top",
  end: 99999,
  toggleClass: "pin-navbar",
});

/* NADA Show Hero Animation */
if ((document.querySelector('.show-hero__accent.yellow') != null) && (document.querySelector('.show-hero__accent.orange') != null) && (document.querySelector('.show-hero__accent.blue') != null)) {
  let tl = gsap.timeline();
  tl.to(
    ".show-hero__accent.yellow", {
    opacity: 0.7,
    scale: 1,
  },
    1.5
  );
  tl.to(
    ".show-hero__accent.orange", {
    opacity: 1,
    scale: 1,
  },
    2
  );
  tl.to(
    ".show-hero__accent.blue", {
    opacity: 1,
    scale: 1,
  },
    2.25
  );
  tl.play();
}



if (document.querySelector('.book-end-link') != null) {

  let bookEnds = gsap.timeline();
  // let bookEndWidth = document.querySelector('.book-end-link').offsetWidth;
  // let chevronWidth = document.querySelector('.book-end-link .chevron-accent').offsetWidth;
  // let moveTo = bookEndWidth - chevronWidth;

  bookEnds.fromTo(".book-end-link .chevron-accent", {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
    duration: .75,
    stagger: .25
  });

  ScrollTrigger.create({
    trigger: '.book-end-link',
    start: "top center",
    end: 99999,
    animation: bookEnds,
  })
}

let fadeOnRightAccents = gsap.utils.toArray(".accent-wrapper .dual-color.slide-accent-from-top .splat");
fadeOnRightAccents.forEach((fadeOnRightAccent) => {
  ScrollTrigger.create({
    trigger: fadeOnRightAccent,
    // markers: {
    //   startColor: 'green',
    //   endColor: 'blue',
    //   indent: 100
    // },
    start: "top 40%",

    animation: gsap.from(fadeOnRightAccent, {
      opacity: 0,
      duration: 1,
      scale: 0,
      stagger: .25
    }),
  });
});

let fadeOnLeftAccentsKeepLeft = gsap.utils.toArray(".accent-wrapper .tri-color.slide-accent-from-top.keep-left .splat");
fadeOnLeftAccentsKeepLeft.forEach((fadeOnLeftAccent) => {
  ScrollTrigger.create({
    trigger: fadeOnLeftAccent,
    // markers: {
    //   startColor: 'green',
    //   endColor: 'blue',
    //   indent: 100
    // },
    // start: "top 50%",
    start: "bottom bottom",
    animation: gsap.from(fadeOnLeftAccent, {
      opacity: 0,
      duration: .75,
      scale: 0,
      stagger: .25
    }),
  });
});

let fadeOnLeftAccents = gsap.utils.toArray(".accent-wrapper .tri-color.slide-accent-from-top.lg-accent-left-all-way .splat");
fadeOnLeftAccents.forEach((fadeOnLeftAccent) => {
  ScrollTrigger.create({
    trigger: fadeOnLeftAccent,
    // markers: {
    //   startColor: 'purple',
    //   endColor: 'fuchsia',
    //   indent: 200
    // },
    start: "top bottom",
    animation: gsap.from(fadeOnLeftAccent, {
      opacity: 0,
      duration: 1,
      scale: 0,
      stagger: .25
    }),
  });
});


let accentsDownOnSide = gsap.utils.toArray(".accent-wrapper .slide-accent-from-top--side");
accentsDownOnSide.forEach((accentDownOnSide) => {
  ScrollTrigger.create({
    trigger: accentDownOnSide,
    start: "top 300px",
    animation: gsap.from(accentDownOnSide, {
      opacity: 0,
      duration: .15
    }),
  });
});


let accentsSmall = gsap.utils.toArray(".accent-wrapper .slide-accent-from-left.sm-accent");
accentsSmall.forEach((accentSmall) => {
  let accentsSmallTl = gsap.to(accentSmall, {
    opacity: .85,
    scale: 1,
    duration: 0.5,
  });
  ScrollTrigger.create({
    trigger: '#top-bar-navigation',
    start: "top top",
    animation: accentsSmallTl,
    // markers: {
    //   startColor: 'purple',
    //   endColor: 'fuchsia',
    //   indent: 200
    // },
  });
});




// var accentsLargeAllWay = gsap.utils.toArray(".accent-wrapper .tri-color.lg-accent-left-all-way .splat");
// accentsLargeAllWay.forEach((accentLargeAllLWay) => {
//   ScrollTrigger.create({
//     trigger: accentLargeAllLWay,
//     start: "top top",
//     animation: gsap.from(accentLargeAllLWay, {
//       opacity: 0,
//       duration: 1.5,
//       stagger: 0.25,
//       scale: 0
//     })
//   });
// });


var accentsLargeHalfWay = gsap.utils.toArray(".accent-wrapper .lg-accent-left-half-way .splat");
accentsLargeHalfWay.forEach((accentLargeHalfWay) => {
  ScrollTrigger.create({
    trigger: accentLargeHalfWay,
    start: "top center",
    animation: gsap.from(accentLargeHalfWay, {
      opacity: 0,
      scale: 0,
      duration: 1.5,
      stagger: 0.25,
    })
  });
});


var accentsLarge = gsap.utils.toArray(".accent-wrapper .lg-accent-left.slide-accent-from-left .splat");
accentsLarge.forEach((accentLarge) => {
  ScrollTrigger.create({
    trigger: accentLarge,
    start: "bottom bottom",
    animation: gsap.from(accentLarge, {
      opacity: 0,
      scale: 0,
      duration: 1,
      stagger: 0.25
    })
  });
});


var accentsLarge2 = gsap.utils.toArray(".accent-wrapper .frame.lg-accent-left .splat");
accentsLarge2.forEach((accentLarge2) => {
  ScrollTrigger.create({
    trigger: accentLarge2,
    start: "bottom center",
    animation: gsap.from(accentLarge2, {
      opacity: 0,
      duration: 1.5,
      scale: 0,
      stagger: 0.05
    })
  });
});
